export default (collection) => {
  return collection.sort((a, b) => {
    if (a.code === "other") return 1;
    else if (b.code === "other") return -1;
    else if (a.name < b.name) return -1;
    else if (b.name < a.name) return 1;
    else return 0;
  });
};
